// extracted by mini-css-extract-plugin
export default {"status_cell":"StatusCell_status_cell__JC9Vl","status_cell_wrapper":"StatusCell_status_cell_wrapper__Bu7tY","exhausted_cell":"StatusCell_exhausted_cell__MFGZe"};